
<template>
  <!-- 物资登记表 -->
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form :inline="true" :model="filteForm" class="demo-form-inline toolbar" style="padding-bottom: 0px"
        @submit.native.prevent>
        <el-form-item label="日期">
          <el-date-picker
            :editable="false"
            v-model="filteForm.dayStr"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" plain @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" plain class="el-icon-plus" @click="dialogFormVisible = true">新增</el-button>
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <el-table :data="list" style="width: 100%" :row-style="tableRowStyle" :header-cell-style="tableHeaderColor">
          <el-table-column label="日期" align="center" prop="dayStr" />
          <el-table-column label="送货人" align="center" prop="songPeople" />
          <el-table-column label="联系方式" align="center" prop="phone" />
          <el-table-column label="消杀人" align="center" prop="xiaoPeople" />
          <el-table-column label="接收对象" align="center" prop="shouPeople" />
          <el-table-column label="消杀时间" align="center" prop="xiaoTime" />
          <el-table-column label="进入时间" align="center" prop="inTime" />
          <el-table-column label="送货内容" align="center" min-width="180" prop="content" />
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" plain @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button type="danger" size="mini" plain @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
          layout="total, prev, pager, next" :total="totalDataNumber" align="center" class="fenye"></el-pagination>
      </div>
      <!-- 弹出新增 -->
      <el-dialog :title="addForm.id==null?'新增物资登记':'编辑物资登记'" 
        :visible.sync="dialogFormVisible" 
        :close-on-click-modal="false"
        :close-on-press-escape="false" 
        class="dangerbuttonxz" 
        @close="closexz">
        <el-form ref="form" :model="addForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label="送货人" :label-width="formLabelWidth" prop="songPeople">
                <el-input v-model.trim="addForm.songPeople" class="commonwidth" placeholder="请输入送货人"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="日期" :label-width="formLabelWidth" prop="xzdate">
                <el-date-picker
                  :editable="false"
                  v-model="addForm.dayStr"
                  type="date"
                  class="commonwidth"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系方式" :label-width="formLabelWidth" prop="phone">
                <el-input v-model.trim="addForm.phone" class="commonwidth" placeholder="请输入联系方式"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="消杀人" :label-width="formLabelWidth" prop="xiaoPeople">
                <el-input v-model.trim="addForm.xiaoPeople" class="commonwidth" placeholder="请输入消杀人"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="接收对象" :label-width="formLabelWidth" prop="shouPeople">
                <el-input v-model.trim="addForm.shouPeople" class="commonwidth" placeholder="请输入接收对象"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="消杀时间" :label-width="formLabelWidth" prop="xiaoTime">
                <el-time-picker
                  v-model="addForm.xiaoTime"
                  format="HH:mm"
                  value-format="HH:mm"
                  class="commonwidth"
                  placeholder="请输入消杀时间">
                </el-time-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="进入时间" :label-width="formLabelWidth" prop="inTime">
                <el-time-picker
                  v-model="addForm.inTime"
                  format="HH:mm"
                  value-format="HH:mm"
                  class="commonwidth"
                  placeholder="请输入进入时间">
                </el-time-picker>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="送货内容" :label-width="formLabelWidth" prop="content">
                <el-input v-model.trim="addForm.content" type="textarea"
                class="bigwidth"
                :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入送货内容"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="closexz">取 消</el-button>
          <el-button type="primary" @click="submitForm('addForm')" :loading="addLoading">确 定</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>
<script>
//入库 ,物资登记
export default {
  name: "WuZiResign",
  data() {
    return {
      addForm: {},
      filteForm: {
        dayStr: ""
      },
      list: [],
      currentPage: 1,
      addLoading:false,
      totalDataNumber: 0,
      pageNum: 1,
      formLabelWidth: '120px',
      loading: false,
      dialogFormVisible: false,

    };
  },
  methods: {
    //点击查询
    onSubmit() {
      if (this.filteForm.dayStr == "") {
        this.getTableData();
      } else {
        this.pageNum = 1;
        this.getTableData();
      }
    },
    closexz() {
      this.dialogFormVisible = false;
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },
    handleEdit(index, row) {
      console.log(index, row);
      this.dialogFormVisible = true; //打开修改弹窗
      this.addForm = Object.assign({}, row); //深拷贝记录
    },
    //删除
    handleDelete(index, row) {
      if (row.bind == false) {
        this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          closeOnClickModal: false,
        }).then(() => {
          let id = row.id;
          console.log(id);
          this.$postJson("dmc/table/deleteWz/" + id).then((res) => {
            if (res.code == 200) {
              console.log(res);
              this.$message({
                type: "success",
                message: res.message,
              });
              this.getTableData();
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          });
        })
      }
    },
    // 新增弹出框点击确定提交信息
    submitForm(datainfo) {
      let param = this.addForm;
      console.log(param);
      this.addLoading = true;
      let url = "omc/table/saveWzIn";
      if(this.addForm.id !=null){
        url = "omc/table/editWzIn";
      }
      this.$postJson(
        url,
        param
      ).then((res) => {
        //旧：dmc/button/add
        console.log(res);
        this.addLoading = false;
        this.dialogFormVisible = false;
        this.$refs.form.resetFields(); //移除校验结果并重置字段值
        if (res.code == "200") {
          setTimeout(() => {
            this.$message({
              message: res.message,
              type: "success",
            });
            this.getTableData();
          }, 300);
          console.log("提交成功!");
        } else {
          setTimeout(() => {
            this.$message({
              message: res.message,
              type: "error",
            });
          }, 300);
        }
      });
    },
    //获取分页的紧急按钮数据  只获取pageSize条数据
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: 10,
        dayStr: this.filteForm.dayStr
      };
      console.log(param);
      this.loading = true;
      this.$postJson("omc/table/selectWuziByDay", param).then(
        (res) => {
          console.log(res);
          //判断是否有数据
          if (res.result.list.length != 0) {
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.total * 1;
            this.list = res.result.list;
            setTimeout(() => {
              this.loading = false;
            }, 200);
          } else {
            this.list = [];
            this.totalDataNumber = 0;
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          }
        }
      );
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getTableData();
    },
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
  },
  created() {
    this.getTableData();
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.buttonlist {
  .buttonlist-m {
    padding: 10px 0 0 5px;
  }
}

.fenye {
  margin: 0;
  padding: 20px 0;
  background: #fff;
}

//新增的dialog
@media screen and (min-width: 1200px) {
  ::v-deep .dangerbuttonxz .el-dialog {
    width: 800px !important;
  }
  .commonwidth{
    width: 260px;
  }
  .bigwidth{
    width: 640px;
  }
}

@media screen and (min-width: 600px) and (max-width: 1199px) {
  ::v-deep .dangerbuttonxz .el-dialog {
    width: 600px !important;
  }
  .commonwidth{
    width: 160px;
  }
  .bigwidth{
    width: 440px;
  }
}
</style>